angular.module('tgaApp').service('scoreService', [
  '$http',
  '$location',
  'localStorageService',
  'userService',
  'envService',
  'security',
  'utilityService',
  'messagingService',
  function ($http, $location, localStorageService, userService, envService, security, utilityService,
    messagingService) {
    const serverAddress = envService.read('serverAddress');

    function getScore(game_id, best) {
      return $http({
        method: 'GET',
        url: `${serverAddress}player/score`,
        params: {
          game_id,
          best,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getLeaderboard(params, callback) {
      return $http({
        method: 'GET',
        url: `${serverAddress}stats/leaderboard`,
        params,
      }).then(
        (response) => {
          if (callback) {
            callback(response);
          }
        },
        (error) => {
          if (callback) {
            callback(error);
          }
        },
      );
    }

    function reportScore(data, callback) {
      messagingService.score(data.points || 0, data.time || 0);
      data = data || {};
      data.hub_id = $location.search().hub_id;
      data.course_id = $location.search().course_id;
      data.session_group_id = $location.search().session_group_id;
      data.challenge_id = $location.search().challenge_id;

      // generate sv string
      const string = [
        data.game_id || 0,
        data.points || 0,
        data.time || 0,
        data.hub_id || 0,
        data.course_id || 0,
        data.session_group_id || 0,
        data.challenge_id || 0,
        security.r,
      ].join('');
      data.sv = utilityService.sha256(string);

      return $http({
        method: 'POST',
        url: `${serverAddress}player/score`,
        data,
      }).then(
        (response) => {
          if (callback) {
            callback(response);
          }
        },
        (error) => {
          // Store info locally
          data.user = userService.getUserData();
          localStorageService.set(Date.now(), data);
          if (callback) {
            callback(error);
          }
        },
      );
    }

    function reportAnswer(data) {
      messagingService.answer(data.correct, data.time || 0);
      return $http({
        method: 'POST',
        url: `${serverAddress}player/answer`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          // Store info locally
          data.user = userService.getUserData();
          localStorageService.set(Date.now(), data);
          // @TODO: We may want to return true here so they can continue playing, etc.
          throw error.data;
        },
      );
    }

    return {
      getScore,
      reportScore,
      reportAnswer,
      getLeaderboard,
    };
  },
]);
